module.exports = __webpack_public_path__ + "img/step-1.d3bf9083.png";